

<div *ngIf="dataId" class="picture-upload-pictures-container">

  <loading-indicator [show]="showLoader"></loading-indicator>

  <button kendoButton fillMode="clear" icon="add" class="picture-upload-add-new-picture" (click)="addPictureItem()" *ngIf="uploadAllowed">Add new picture</button>

  <form novalidate #picturesForm="ngForm" style="display: contents;">

    <kendo-listview [data]="pagedPictures" containerClass="picture-upload-list-container">

      <ng-template kendoListViewItemTemplate let-dataItem>

        <div class="picture-upload-image-container">
          <img *ngIf="dataItem.isLoaded" [src]="dataItem.dataUrl" [class.active]="true" alt=" " />

          <div class="picture-upload-picture-details" (click)="startEditMode(dataItem)" [class.active]="!dataItem.editMode">
            <span>{{getPictureTypeDescription(dataItem)}}</span>
            <br />
            <span>{{dataItem.description}}</span>
          </div>
        </div>

        <div class="picture-upload-picture-details-edit" [class.active]="dataItem.editMode">

          <input type="text" [(ngModel)]="dataItem.description" [ngModelOptions]="{standalone: true}" (ngModelChange)="itemChanged(dataItem);">

          <kendo-dropdownlist [(ngModel)]="dataItem.pictureTypeId" [ngModelOptions]="{standalone: true}"
                              [data]="imageTypes"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true">
          </kendo-dropdownlist>
          <div class="picture-upload-file-input-container">
            <kendo-upload class="picture-upload-file-input"
                          [restrictions]="uploadRestrictions"
                          [autoUpload]="false"
                          [multiple]="false"
                          (select)="fileInputChanged($event, dataItem)"></kendo-upload>
          </div>
          <div class="selected-file-border" *ngIf="dataItem.isFileSelected">
            <div class="selected-file-name" title="{{ currentFile.name }}">
              {{ currentFile.name }}
            </div>
            <span class="k-file-size file-size">{{ formatFileSizeInKB(currentFile.size) }}</span>
          </div>
          <div class="picture-upload-picture-buttons">
            <button kendoButton
                    fillMode="clear"
                    icon="save"
                    (click)="savePicture(dataItem)"
                    *ngIf="dataItem.isFileSelected"
                    [disabled]="dataItem.saveInProgress"></button>
            <button kendoButton fillMode="clear" icon="delete" (click)="deletePicture(dataItem)"></button>
            <button kendoButton fillMode="clear" icon="close" (click)="endEditMode(dataItem)"></button>
          </div>
        </div>
      </ng-template>
    </kendo-listview>
  </form>
  <kendo-datapager class="picture-upload-pictures-datapager" [pageSize]="pageSize"
                   [skip]="skip"
                   [total]="listSource.length"
                   (pageChange)="onPageChange($event)">
    <ng-template kendoDataPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-datapager-prev-buttons class="picture-upload-prev-buttons"></kendo-datapager-prev-buttons>
      <div style=" position: relative; left: 28px;">{{currentPage}}</div> 
      <kendo-datapager-next-buttons class="picture-upload-next-buttons"></kendo-datapager-next-buttons>
      <kendo-datapager-info class="picture-upload-datapager-info"></kendo-datapager-info>
    </ng-template>
  </kendo-datapager>

</div>
